angular.module('app.filters').filter('numberWithUnit', function($filter) {
    const numberFilter = $filter('number');

    return function(number, fractionSize, unit) {
        if (number == null) { return ''; }
        unit || (unit = '');
        return `${numberFilter(number, fractionSize)} ${unit}`;
    };
});


// WEBPACK FOOTER //
// ./filters/number_with_unit.js